import { HttpHeaders } from '@angular/common/http';

// Only the subproject is named: the API resolves a subproject's project itself. ClientId is left
// for ClientHttpInterceptor to add — a subproject never crosses a client, so the selected one is
// still correct even before the store has caught up to the switch.
export function subprojectAddressHeaders(subprojectId: number): HttpHeaders {
  return new HttpHeaders({ SubprojectId: String(subprojectId) });
}
